export default storage => (typeof window !== 'undefined' && window[storage]) || {
    _data: {},
    setItem(id, val) { this._data[id] = String(val) },
    getItem(id) {
        return Object.prototype.hasOwnProperty.call(this._data, id) ? this._data[id] : undefined
    },
    removeItem(id) { delete this._data[id] },
    clear() { this._data = {} }
}
